import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import AccessibleIcon from '../../AccessibleIcon'
import styles, { wrapperTheme, wrapperSize, iconColor, iconSize } from './styles'

const ItemIcon = ({ theme, size, withBackground, icon }) => (
  <div className={cx(styles.wrapper, withBackground && wrapperTheme(theme), wrapperSize(size))}>
    <AccessibleIcon icon={icon} color={iconColor(theme)} size={iconSize(size, withBackground)} />
  </div>
)

ItemIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool,
}

export default ItemIcon
